import React, { useState } from 'react';
import Rating from '../Rating';

export default function Testimonial({ data = [] }) {
  const [activeTab, setActiveTab] = useState(2);
  const handleTabClick = (tabNumber) => {
    setActiveTab(tabNumber);
  };
  return (
    <div className='cs_tabs cs_style1'>
      <ul className='cs_tab_links'>
        <li className={activeTab === 1 ? 'active' : ''}>
          <div className='cs_tab_link_in' onClick={() => handleTabClick(1)}>
            <div className='cs_testimonial_1_avatar'>
              <img src={data[0]?.avatar} alt='Avatar' />
              <div className='cs_testimonial_1_avatar_right'>
                <h3 className='cs_fs_24 cs_semibold mb-0'>{data[0]?.name}</h3>
                <p className='cs_heading_color mb-0'>{data[0]?.address}</p>
              </div>
            </div>
          </div>
        </li>
        <li className={activeTab === 2 ? 'active' : ''}>
          <div className='cs_tab_link_in' onClick={() => handleTabClick(2)}>
            <div className='cs_testimonial_1_avatar'>
              <img src={data[1]?.avatar} alt='Avatar' />
              <div className='cs_testimonial_1_avatar_right'>
                <h3 className='cs_fs_24 cs_semibold mb-0'>{data[1]?.name}</h3>
                <p className='cs_heading_color mb-0'>{data[1]?.address}</p>
              </div>
            </div>
          </div>
        </li>
        <li className={activeTab === 3 ? 'active' : ''}>
          <div className='cs_tab_link_in' onClick={() => handleTabClick(3)}>
            <div className='cs_testimonial_1_avatar'>
              <img src={data[2]?.avatar} alt='Avatar' />
              <div className='cs_testimonial_1_avatar_right'>
                <h3 className='cs_fs_24 cs_semibold mb-0'>{data[2]?.name}</h3>
                <p className='cs_heading_color mb-0'>{data[2]?.address}</p>
              </div>
            </div>
          </div>
        </li>
      </ul>
      <div className='cs_tab_body'>
        {activeTab === 1 && (
          <div className='cs_testimonial cs_style_1'>
            <img src='/images/icons/quote.svg' alt='Icon' />
            <p>{data[0]?.content}</p>
            <Rating ratingNumber={5} />
          </div>
        )}
        {activeTab === 2 && (
          <div className='cs_testimonial cs_style_1'>
            <img src='/images/icons/quote.svg' alt='Icon' />
            <p>{data[1]?.content}</p>
            <Rating ratingNumber={5} />
          </div>
        )}
        {activeTab === 3 && (
          <div className='cs_testimonial cs_style_1'>
            <img src='/images/icons/quote.svg' alt='Icon' />
            <p>{data[2]?.content}</p>
            <Rating ratingNumber={5} />
          </div>
        )}
      </div>
    </div>
  );
}
